import AuthService from '@services/AuthService';
import axios from '@services/InterceptorsForAxiosRequests';
import { buildQueryString } from '@utils/Functions';
import { notificationsApi } from '@routes/api/notifications';

class NotificationsService {
  getNotificaciones() {
    const token = AuthService.getAuthHeader();
    const filters = buildQueryString({});
    const path = notificationsApi.notificaciones(filters);
    return axios.get(path, token);
  }

  crearNotificacion() {
    const token = AuthService.getAuthHeader();
    const filters = buildQueryString({});
    const path = notificationsApi.notificaciones(filters);
    return axios.post(path, token);
  }

  modificarNotificacion(id) {
    const token = AuthService.getAuthHeader();
    const filters = buildQueryString({});
    const path = notificationsApi.crearNotificacion(filters, id);
    const body = {};
    return axios.patch(path, body, token);
  }

  getPreferencias() {
    const token = AuthService.getAuthHeader();
    const filters = buildQueryString({});
    const path = notificationsApi.preferencias(filters);
    return axios.get(path, token);
  }

  modificarPreferencias(body) {
    const token = AuthService.getAuthHeader();
    const filters = buildQueryString({});
    const path = notificationsApi.preferencias(filters);
    return axios.put(path, body, token);
  }
  notificacionLeida(id) {
    const token = AuthService.getAuthHeader();
    const path = notificationsApi.notificacionLeida(id);
    return axios.patch(path, {}, token);
  }
}

export default new NotificationsService();
